import React, {Component} from "react"
import {Row, Col} from "react-bootstrap"
import {InjectedIntl} from "react-intl"
import Link from "@irati/ui/src/Link"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import {Body} from "@irati/ui/src/Typography"
import authentication from "@irati/auth"
import EmojiWithText from "../../../components/EmojiWithText"
import {PaddingGrid, WhiteBackground} from "../../../components/shared"
import Callback from "../../../components/Upsell/Callback"
import {
  InformationText,
  WhiteH2,
  WhiteH4,
  MobileSubHeader,
  MobileCallbackWrapper,
  SpaceBetween,
  BannerHeadings,
  StyledRow,
  MobileBanner,
  StyledBanner,
  TermsWrapper,
  TermsText
} from "./styles"

const upsellBanner = "https://res.cloudinary.com/perkbox/image/upload/v1556812328/deals-light-ui/web/medical/medicalUpsell.jpg"

const bannerProps = {
  backgroundPosition: "0 34%",
  bannerImg: upsellBanner,
  minHeight: "500",
  tabletMinHeight: "200",
  cutOffBottom: false
}

interface Props extends InjectedIntl {}

class MedicalUpsell extends Component<Props> {
  render() {
    const {formatMessage} = this.props
    const publicName = authentication.userTenant().public_name
    const privacyLink = (
      <Link
        href={formatMessage({
          id: "medical.upsellPage.smallPrint.privacyHref"
        })}
        rel="noopener noreferrer"
        target="_blank">
        <FormattedMessage id="medical.upsellPage.smallPrint.privacyText" />
      </Link>
    )
    const termsLink = (
      <Link
        href={formatMessage({
          id: "medical.upsellPage.smallPrint.termsHref"
        })}
        rel="noopener noreferrer"
        target="_blank">
        <FormattedMessage id="medical.upsellPage.smallPrint.termsText" />
      </Link>
    )
    return (
      <WhiteBackground>
        <Row>
          <Col xsHidden lg={12}>
            <StyledBanner {...bannerProps}>
              <PaddingGrid>
                <SpaceBetween>
                  <BannerHeadings>
                    <WhiteH2 base>
                      <FormattedMessage id="medical.upsellPage.header" values={{publicName}} />
                    </WhiteH2>
                    <WhiteH4 large>
                      <FormattedMessage id="medical.upsellPage.subHeader" />
                    </WhiteH4>
                  </BannerHeadings>
                  <Callback />
                </SpaceBetween>
              </PaddingGrid>
            </StyledBanner>
          </Col>
          <Col xs={12} smHidden mdHidden lgHidden>
            <MobileBanner {...bannerProps}>
              <PaddingGrid>
                <WhiteH2 base>
                  <FormattedMessage id="medical.upsellPage.header" values={{publicName}} />
                </WhiteH2>
              </PaddingGrid>
            </MobileBanner>
            <MobileSubHeader>
              <FormattedMessage id="medical.upsellPage.subHeader" />
            </MobileSubHeader>
            <MobileCallbackWrapper>
              <Callback />
            </MobileCallbackWrapper>
          </Col>
        </Row>

        <PaddingGrid>
          <StyledRow>
            <Col xs={12} md={8}>
              <InformationText>
                <Body large maxWidth="100%" marginBottom={1} weight="light">
                  <FormattedMessage id="medical.upsellPage.text.para1" />
                </Body>
                <Body large maxWidth="100%" marginBottom={1} weight="light">
                  <FormattedMessage id="medical.upsellPage.text.para2" />
                </Body>
                <Body large maxWidth="100%" marginBottom={1} weight="light">
                  <FormattedMessage id="medical.upsellPage.text.para3" />
                </Body>
              </InformationText>
              <Body small marginBottom={1}>
                <FormattedMessage id="medical.upsellPage.features.header" values={{publicName}} />
              </Body>
              <EmojiWithText
                emoji="female-doctor"
                text={formatMessage({
                  id: "medical.upsellPage.features.feature1"
                })}
              />
              <EmojiWithText
                emoji="calling"
                text={formatMessage({
                  id: "medical.upsellPage.features.feature2"
                })}
              />
              <EmojiWithText
                emoji="fast_forward"
                text={formatMessage({
                  id: "medical.upsellPage.features.feature3"
                })}
              />
              <EmojiWithText
                emoji="spiral_calendar_pad"
                text={formatMessage({
                  id: "medical.upsellPage.features.feature4"
                })}
              />
              <EmojiWithText
                emoji="hourglass_flowing_sand"
                text={formatMessage({
                  id: "medical.upsellPage.features.feature5"
                })}
              />
              <EmojiWithText
                emoji="file_folder"
                text={formatMessage({
                  id: "medical.upsellPage.features.feature6"
                })}
              />
            </Col>
          </StyledRow>
          <Row>
            <Col xs={12} md={8}>
              <TermsWrapper>
                <TermsText>
                  <FormattedMessage id="medical.upsellPage.smallPrint.line1" />
                </TermsText>
                <strong>
                  <TermsText>
                    <FormattedMessage id="medical.upsellPage.smallPrint.line2" />
                  </TermsText>
                </strong>
                <TermsText>
                  <FormattedMessage id="medical.upsellPage.smallPrint.privacy" values={{link: privacyLink}} />
                  <br />
                  <FormattedMessage id="medical.upsellPage.smallPrint.terms" values={{link: termsLink}} />
                </TermsText>
                <TermsText>
                  <FormattedMessage id="medical.upsellPage.smallPrint.copyright" />
                </TermsText>
              </TermsWrapper>
            </Col>
          </Row>
        </PaddingGrid>
      </WhiteBackground>
    )
  }
}

export default injectIntl(MedicalUpsell)
